module.exports = __webpack_public_path__ + "img/gift.0532f72b.svg";